import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditScoreProcessPayloadSchema = z.object({
    score: z.number().optional(),
});

export class CreditScoreProcessPayload extends FromSchema(CreditScoreProcessPayloadSchema) {
    score?: number;
}
